import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { Enums, Paths } from '@utils/constants';
import { axios } from '@utils/lib';
import { addLoading, removeLoading } from './appAction';

export const forceLogout = createAction('auth/forceLogout');

export const login = createAsyncThunk(
  'auth/login',
  async (body: ILoginForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<ILoginRes>(
        Enums.HTTP_METHOD.POST,
        Paths.LOGIN,
        body,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const response = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.LOGOUT,
      );
      return response.data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const userRegisterAsync = createAsyncThunk(
  'auth/userRegisterAsync',
  async (body: ICreateUserForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.USER_REGISTER,
        body,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const appConfigAsync = createAsyncThunk(
  'auth/appConfigAsync',
  async (body: IAppConfigForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IAppConfig>(
        Enums.HTTP_METHOD.POST,
        Paths.CONFIG_APP,
        body,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const dbConfigAsync = createAsyncThunk(
  'auth/dbConfigAsync',
  async (request: IDbConfigRequest, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<ISettingRes>(
        Enums.HTTP_METHOD.POST,
        Paths.CONFIG_DB,
        request.body,
        {
          headers: {
            Authorization: `Bearer ${request.token}`,
          },
        },
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
